import sanityClient from '@sanity/client';

export default sanityClient ({
    projectId: "gf6qmp8x",
    dataset: "production",
    apiVersion: '2022-07-08',
})